const routes = [
    {
      name: 'terms-of-service',
      path: 'terms-of-service',
      component: () => import('@/view/pages/TermsOfService.vue'),
    },
    {
      name: 'privacy-policy',
      path: 'privacy-policy',
      component: () => import('@/view/pages/PrivacyPolicy.vue'),
    }
];

export default routes;